import { createFileRoute } from '@tanstack/react-router'

import { CustomerPage } from '#/modules/customers/customer-page'

export const Route = createFileRoute('/_shell/customers/$customerId')({
  component: function CustomerPageRoute() {
    const { customerId } = Route.useParams()
    return <CustomerPage customerId={customerId} />
  },
})
